<div class="table table-responsive">
        <table class="table">
        <thead>
            <tr class="custom-table-head">
                <th>
                    <a style="cursor: pointer" (click)="currentPage = 0; getItems()" title="Actualiser">
                        <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                </th>
                <th>Matricule</th>
                <th>Nom Prenom</th>
                <th>Garantie</th>
                <th>Acte/produit</th>
                <th>Quantité</th>
                <th>Prestataire</th>
                <th>Date</th>
                <th>Montant</th>
                <th>Part assurance</th>
                <th>Dépassement</th>
                <th>Part patient</th>
                <th>Montant tpg</th>
                <!-- <th>Total indiv</th> -->
                <th class="txt-align-center">Photo</th>
            </tr>
        </thead>

        <tbody>
            <tr [class.isAssure]="item?.statut_codification =='A'" [class.isSupplementaire]="item?.is_supplementaire" 
                *ngFor="let item of items; let indice = index">
                <td class="txt-align-center">{{ currentPage>1?(((currentPage - 1) * this.itemsPerPage) + (indice+1)):indice+1 }}</td>
                <td>{{ item?.matricule }}</td>
                <td>{{ item?.beneficiaire_nom }} {{ item?.beneficiaire_prenom }}</td>
                <td>{{ item?.garantie_libelle }}</td>
                <td>{{ item?.acte_libelle || item?.medicament_libelle }}</td>
                <td>{{ (item?.quantie || item?.quantite_vendue || 1) | integerFormat }}</td>
                <td>{{ item.prestataire_libelle }}</td>
                <td>{{ item?.created_at | dateTimeFormat}}</td>
                <td>{{ item?.montant | integerFormat }}</td>
                <td>{{ item?.part_assurance | integerFormat }}</td>
                <td>{{ item?.depassement | integerFormat }}</td>
                <td>{{ item?.part_patient | integerFormat }}</td>
                <td>{{ item?.montant_tpg | integerFormat }}</td>
                <td>
                    <img [src]="item.beneficiaire_image_url | safe" (error)="handleImageError(item)" 
                         style="width: 30px; height: 30px; display: block; border-radius: 50px;" />
                </td>
            </tr>
        </tbody>

        <tfoot>
            <tr *ngIf="items && items.length > 0">
                <td colspan="19"> <!-- Updated colspan to match total columns -->
                    <div class="row pagination-part">
                        <div class="col-md-9" style="text-align: center">
                            <pagination [maxSize]="5" [boundaryLinks]="true" [itemsPerPage]="itemsPerPage"
                                [totalItems]="totalItems" [(ngModel)]="currentPage" class="pagination-sm"
                                previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
                                (pageChanged)="pageChanged($event)">
                            </pagination>
                        </div>

                        <div class="col-md-3">
                            <div class="paginator-per-page">
                                <app-element-by-page-paginator (paginationChange)="changePaginationSize($event)"
                                    [defaultItemPerPage]="itemsPerPage">
                                </app-element-by-page-paginator>

                                <span class="span_total_entree pull-right">Total : {{ totalItems }}</span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>

            <tr *ngIf="!items || items.length == 0">
                <td colspan="19"> <!-- Updated colspan to match total columns -->
                    <div class="col-md-12 txt-align-center">
                        Aucune donnée disponible
                    </div>
                </td>
            </tr>
        </tfoot>
    </table>
</div>